module.exports = __webpack_public_path__ + "img/home_icon_selected_mobile.c7cfa34a.svg";